export default __webpack_public_path__ + "static/media/Dime2.79fd7294.png";